import styled from "styled-components";
import { Modal as AntModal, Button as AntButton } from "antd";
import { PocketMoneyBG } from '@assets'

export const Modal = styled(AntModal)`
  .ant-modal-content {
    background-image: url(${PocketMoneyBG});
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    width: 365px;
    height: 423px;
    box-shadow: none !important;
    background-color: transparent !important;
  }
  @media screen and (max-width: 413px) {
    width: 265px !important;
    height: 323px !important;
    .ant-modal-content {
      width: 265px;
      height: 323px;
    }
  }
`;

export const ModalTitle = styled.p`
  color: ${props => props.theme.white};
  font-size: 22px;
  font-weight: bold;
  margin-top: 80px;
  margin-bottom: 10px;
`;

export const ModalLabel = styled.p`
  font-size: 14px;
  text-align: center;
  font-weight: 400;
  color: ${props => props.theme.primarySolid};
  margin-bottom: 20px;
`;

export const StyledInput = styled.input`
  width: 40px !important;
  height: 40px !important;
  border-radius: 5px !important;
  text-align: center !important;
  border: 1px solid ${(props) => (props.status === "error" ? "red" : "#E1CCE0")} !important;
  font-size: 17px !important;
  -moz-appearance: textfield;
  appearance: textfield;
  ::-webkit-inner-spin-button,
  ::-webkit-outer-spin-button {
    -webkit-appearance: none; /* WebKit */
    margin: 0;
  }
  ::-webkit-inner-spin-button:disabled,
  ::-webkit-outer-spin-button:disabled {
    display: none;
  }
  @media screen and (max-width: 380px) {
    width: 30px !important;
    height: 30px !important;
  }
  @media screen and (max-width: 320px) {
    width: 25px !important;
    height: 25px !important;
  }
`;

export const Button = styled(AntButton)`
  width: 208px !important;
  height: 47px !important;
  border-radius: 27px;
`;